import styled from "styled-components";
import theme from "@/styles/theme";

export const Card = styled.div<{ disabled: boolean }>`
  width: 100%;
  padding: 15px;
  border-radius: 5px;
  background: ${({ disabled }) =>
    disabled
      ? "#d3d3d3"
      : "linear-gradient(to top right, #a9884d 80%, #c8a05e 50%)"};
  box-sizing: border-box;
  opacity: ${({ disabled }) => (disabled ? 0.5 : 1)};

  .sphere-label {
    display: flex;
    font-size: ${theme.fontSize.md};
    flex-direction: row;
    justify-content: space-between;
    span {
      color: ${theme.colors.palete.brownLight};
      font-family: sans-serif;
      font-weight: 700;
      @media ${theme.devices.tablet} {
        font-size: ${theme.fontSize.mm};
        font-weight: 900;
        width: 80%;
      }
    }
  }

  .info-container {
    display: flex;
    font-size: ${theme.fontSize.md};
    flex-direction: row;
    justify-content: space-between;
    color: ${theme.colors.palete.brownLight};
    cursor: ${({ disabled }) => (disabled ? "not-allowed" : "default")};
    margin-top: 4vh;
    @media ${theme.devices.tablet} {
      display: flex;
      flex-direction: column;
      align-items: center;
      row-gap: 2vh;
    }
    .info-item {
      display: flex;
      flex-direction: column;
      row-gap: 1vh;
    }
  }

  .switch-container {
    display: flex;
    flex-direction: row;
    column-gap: 1vw;
    @media ${theme.devices.tablet} {
      display: flex;
      flex-direction: column;
      align-self: center;
      row-gap: 3vh;
    }
    .switch-item {
      display: flex;
      flex-direction: row;
      column-gap: 0.5vw;
      @media ${theme.devices.tablet} {
        column-gap: 4vw;
        justify-content: end;
      }
    }
  }
`;

export const IOSSwitch = styled.input.attrs({ type: "checkbox" })`
  width: 42px;
  height: 26px;
  padding: 0;
  appearance: none;
  position: relative;
  border-radius: 13px;
  background-color: #cdcdcd;
  transition: background-color 0.5s;
  cursor: pointer;

  &:checked {
    background-color: #3A7D44;
    &::before {
      transform: translateX(16px);
      background-color: #fff;
    }
  }

  &:focus-visible::before {
    border: 6px solid #fff;
    background-color: #33cf4d;
  }

  &:disabled {
    opacity: 0.7;
    cursor: not-allowed;
    &::before {
      background-color: #bdbdbd;
    }
  }

  &::before {
    content: "";
    position: absolute;
    top: 2px;
    left: 2px;
    width: 22px;
    height: 22px;
    border-radius: 50%;
    background-color: #fff;
    transition: transform 0.3s;
    box-sizing: border-box;
  }
`;
export const SwitchContainer = styled.div`
  display: flex;
  flex-direction: column;
  .row-container {
    display: flex;
    flex-direction: row;
    column-gap: 1vw;
    margin-top: 1vh;
    align-self: center;
  }
`;
